<template>
    <b-modal id="login-modal" v-model="$store.state.loginModalOpen" title="Přihlášení" no-footer>
        <b-form @submit="login">
            <b-form-group
                label-cols="6"
                content-cols="6"
                label="E-mail"
                label-for="login-email"
                class="mb-2"
            >
                <b-form-input id="login-email" v-model="currentEmail" required type="email"/>
            </b-form-group>
            <b-form-group
                label-cols="6"
                content-cols="6"
                label="Heslo"
                label-for="login-password"
                class="mb-2"
            >
                <b-form-input
                    id="login-password"
                    v-model="currentPassword"
                    required
                    type="password"
                />
            </b-form-group>

            <b-form-row>
                <b-col class="d-flex flex-column justify-content-end">
                    <router-link
                        to="/reset-password"
                        class="text-secondary fw-bold fs-base"
                        @click="close()"
                    >
                        Zapomenuté heslo
                    </router-link>
                </b-col>
                <b-col>
                    <b-form-row v-if="wrongPassword">
                        <b-col class="text-danger fw-bold mb-2">
                            Špatný email nebo heslo.
                        </b-col>
                    </b-form-row>
                    <b-button
                        type="submit"
                        :loading="requestInProgress"
                        :disabled="requestInProgress"
                        loading-text="Přihlásit se "
                    >
                        Přihlásit se
                    </b-button>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col class="mt-3">
                    Ještě nemáš účet?
                    <b-link
                        @click="openRegistrationModal()"
                    >
                        Registruj se!
                    </b-link>
                </b-col>
            </b-form-row>
        </b-form>
    </b-modal>
</template>

<script lang="ts">
import { AxiosError } from 'axios';
import authService from '@/api/AuthService';
import { defineComponent, reactive, watchEffect } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
    setup() {
        const data: {
            currentEmail: string;
            currentPassword: string;
            wrongPassword: boolean;
            requestInProgress: boolean;
        } = reactive({
            currentEmail: '',
            currentPassword: '',
            wrongPassword: false,
            requestInProgress: false,
        });

        const store = useStore();

        watchEffect(async() => {
            // Reset the window when it is closed
            if (!store.state.loginModalOpen) {
                data.wrongPassword = false;
                data.currentEmail = '';
                data.currentPassword = '';
            }
        });
        return data;
    },
    methods: {
        async login(event: Event): Promise<void> {
            event.preventDefault();
            if (this.requestInProgress) return;

            this.requestInProgress = true;
            this.wrongPassword = false;
            const success = await authService.login(
                { email: this.currentEmail, password: this.currentPassword },
                this.handleLoginError,
            );
            if (success) {
                this.$store.commit('closeLoginModal');
            }
            this.requestInProgress = false;
        },
        handleLoginError(error: AxiosError): boolean {
            if (error?.response?.status === 401) {
                this.wrongPassword = true;
                return true;
            }
            return false;
        },
        close(): void {
            this.$store.commit('closeLoginModal');
        },
        openRegistrationModal(): void {
            this.$store.commit('closeLoginModal');
            this.$store.commit('openRegistrationModal');
        },
    },
});
</script>
